import { MappedUserInfo } from "Shared/models/MappedUserInfo";
import { getLoggingDeviceType } from "./loggerHelper";
import { EventDescriptor } from "./types-and-interfaces/EventDescriptor";
import { HomepageDomLoadedEvent, HomepageDomLoadedEventData } from "./types-and-interfaces/HomepageDomLoadedEvent";
import { EventType } from "./types-and-interfaces/logging-types-constants";
import { ROLE_CODES } from "Services/constants";
import { SearchClickedEvent, SearchClickedEventData } from "./types-and-interfaces/SearchClickedEvent";
import dayjs from "dayjs";
import { UserLoginRegisterEvent, UserLoginRegisterEventData } from "./types-and-interfaces/UserLoginEvent";

const getUserRoleCode = (userInfo: MappedUserInfo) =>
	userInfo?.RoleCode && userInfo?.RoleCode !== ROLE_CODES.WEB_ANONYMOUS ? userInfo?.RoleCode : "WebAnonymous";

export const useEventDescriptions = () => {
	const EVENT_DESCRIPTIONS = new Map<EventType, EventDescriptor>([
		[
			"homepage_dom_loaded",
			{
				customProperties: (data: HomepageDomLoadedEventData): HomepageDomLoadedEvent => ({
					culture: `${window.location.pathname.slice(-3, -1).toLowerCase()}-${window.location.pathname
						.slice(-6, -4)
						.toUpperCase()}`,
					device: getLoggingDeviceType(),
					role_code: getUserRoleCode(data.userInfo),
					program_code: data.userInfo.ProgramCodesWithLevels?.reduce(
						(acc, p) => `${acc}|${p.ProgramCode}`,
						""
					),
					program_level: data.userInfo.ProgramCodesWithLevels?.reduce(
						(acc, p) => `${acc}|${p.ProgramLevel}`,
						""
					),
				}),
			},
		],
		[
			"search_clicked",
			{
				customProperties: (data: SearchClickedEventData): SearchClickedEvent => ({
					culture: data.culture,
					departure_journey_date: data.departureDate ? dayjs(data.departureDate).format("YYYY-MM-DD") : null,
					destination_iata: data.destinationCode,
					device: getLoggingDeviceType(),
					market: data.market,
					origin_iata: data.originCode,
					pax_adult_count: data.adults,
					pax_children_count: data.children,
					pax_infant_count: data.infants,
					pax_teen_count: data.teens,
					promo_codes: data.promoCodes.join("|"),
					return_journey_date: data.returnDate ? dayjs(data.returnDate).format("YYYY-MM-DD") : null,
					trip_type: data.numberOfJourneys === 1 ? "O" : "R",
				}),
			},
		],
		[
			"user_login",
			{
				customProperties: (data: UserLoginRegisterEventData): UserLoginRegisterEvent => ({
					ibe_release: data.loginInfo?.tealium?.ibeRelease,
					organization: data.loginInfo?.tealium?.organizationName,
					user_be_level: data.loginInfo?.tealium?.userBeLevel,
					user_dc_level: data.loginInfo?.tealium?.userDcLevel,
					user_programs: data.loginInfo?.tealium?.userPrograms.join("|"),
					user_role: data.loginInfo?.tealium?.userRole,
				}),
			},
		],
		[
			"user_register",
			{
				customProperties: (data: UserLoginRegisterEventData): UserLoginRegisterEvent => ({
					ibe_release: data.loginInfo.tealium.ibeRelease,
					organization: data.loginInfo.tealium.organizationName,
					user_be_level: data.loginInfo.tealium.userBeLevel,
					user_dc_level: data.loginInfo.tealium.userDcLevel,
					user_programs: data.loginInfo.tealium.userPrograms.join("|"),
					user_role: data.loginInfo.tealium.userRole,
				}),
			},
		],
		["user_logout", {}],
	]);

	return { EVENT_DESCRIPTIONS };
};
